import React, { memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'
import { TableSearch } from 'src/components/shared/table/TableSearch'

interface Props {
  searchQuery: string
  onSearchQueryChange(query: string): void
  onRefresh(): void
}

/** The table card's white header, as on `GigsafeUsersTableToolbar`. Search filters in memory. */
const InternalUsersToolbarComponent = ({ searchQuery, onSearchQueryChange, onRefresh }: Props) => {
  return (
    <div
      css={tw`flex flex-row items-center gap-4 rounded-t-lg border-0 border-b border-t border-solid border-shades-100 bg-shades-0 px-4 py-3`}
    >
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={onSearchQueryChange}
        width={320}
        debounceMs={150}
        inputDataTestId="internal-users-search-input"
      />
      <div css={tw`ml-auto`}>
        <Button
          size="small"
          color="white"
          leftIcon={<GSIcon iconName="gs_arrows_repeat" size={20} css={tw`text-shades-1000`} />}
          onClick={onRefresh}
          data-testid="internal-users-refresh-button"
        >
          Refresh
        </Button>
      </div>
    </div>
  )
}

export const InternalUsersToolbar = memo(InternalUsersToolbarComponent)
